module.exports = __webpack_public_path__ + "img/videoImg.66eb6f5b.png";